import { render, staticRenderFns } from "./IconAndButton.vue?vue&type=template&id=715f8f72&scoped=true"
import script from "./IconAndButton.vue?vue&type=script&lang=js"
export * from "./IconAndButton.vue?vue&type=script&lang=js"
import style0 from "./IconAndButton.vue?vue&type=style&index=0&id=715f8f72&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715f8f72",
  null
  
)

export default component.exports